import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";

import { css } from "styled-components";

export default {
    css: css`
        body {
            overflow-x: hidden;
        }
        .ContactUSPage {
            max-width: 700px;
            margin: auto;
            padding-left: 20px;
            padding-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 350px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        }
        .news-description {
            margin-top: 20px !important;
            font-family: ${TYPOGRAPHY.fontFamily.montserrat};
            color: ${COLORS.secondaryNavyThree};
            line-height: 1.3;
            font-size: ${TYPOGRAPHY.size.mbase};
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-family: ${TYPOGRAPHY.fontFamily.montserrat} !important;
                            color: ${COLORS.black}!important;
                            font-size: ${TYPOGRAPHY.size.base} !important;
                            font-weight: ${TYPOGRAPHY.weight.base}!important;
                        `,
                        css`
                            font-family: ${TYPOGRAPHY.fontFamily.montserrat} !important;
                            color: ${COLORS.black}!important;
                            font-size: ${TYPOGRAPHY.size.base} !important;
                            font-weight: ${TYPOGRAPHY.weight.base}!important;
                        `,
                        css`
                            font-family: ${TYPOGRAPHY.fontFamily.montserrat} !important;
                            color: ${COLORS.black}!important;
                            font-size: ${TYPOGRAPHY.size.base} !important;
                            font-weight: ${TYPOGRAPHY.weight.base}!important;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        }
        .categoryDetailSection {
            padding-top: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 40px 15px 15px;
                        `,
                        null,
                    ],
                    "minMax",
                )}
            > div[class^="GridOffset"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-flow: column;
                                padding: 30px 0;
                            `,
                            css`
                                flex-flow: column;
                                padding: 30px 0;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    )}
                > div[class^="GridItemStyle"]:first-child {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    order: 3;
                                `,
                                css`
                                    order: 3;
                                `,
                                css``,
                                null,
                            ],
                            "minMax",
                        )}
                }
                > div[class^="GridItemStyle"]:last-child {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [null, null, null, null], "minMax")}
                }
            }
        }
        .companyPageSection {
            padding-top: 0px;
            padding-left: 20px;
            padding-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 15px 15px;
                        `,
                        css`
                            padding: 0 15px 15px;
                        `,
                        css`
                            padding: 0 15px 15px;
                        `,
                        null,
                    ],
                    "minMax",
                )}
            > div[class^="GridOffset"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-flow: column-reverse wrap;
                                padding: 0 0;
                            `,
                            css`
                                flex-flow: column-reverse wrap;
                                padding: 0 0;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    )}
                > div[class^="GridItemStyle"]:last-child {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    display: none;
                                `,
                                css`
                                    display: none;
                                `,
                                css`
                                    display: none;
                                `,
                                null,
                            ],
                            "minMax",
                        )}
                }
            }
        }
        .company-History {
            max-width: 754px;
            margin: auto;
            h1 {
                font-family: "Barlow";
                font-size: 28px;
                font-weight: 500;
                color: #006ed2;
                text-transform: uppercase;
            }
            h2 {
                font-family: "Barlow";
                font-size: 23px;
                font-weight: 500;
                color: #006ed2;
                text-transform: uppercase;
            }
            h3 {
                font-family: "Dosis";
                font-size: 18px;
                font-weight: 600;
                color: #134078;
                text-transform: uppercase;
            }
            p {
                opacity: 1;
                color: rgba(0, 0, 0, 1);
                font-family: "Montserrat";
                font-size: 16px;
                font-weight: 400;
                font-style: normal;
                letter-spacing: 0px;
                text-align: left;
                line-height: 22px;
            }
            > div > div {
                padding-right: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding-right: 20px;
                        `,
                        css`
                            padding-right: 20px;
                        `,
                        css`
                            padding-right: 20px;
                        `,
                        css`
                            padding-right: 0px;
                        `,
                        css`
                            padding-right: 0px;
                        `,
                    ])}
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 350px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        }
        body {
            .maxWidthNoPadding {
                max-width: 100% !important;
                padding: 0 !important;
            }
        }
        body {
            .maxWidthNoPadding {
                max-width: 100% !important;
                padding: 0 !important;
            }
        }
        .TecLinkButton {
            max-width: 360px;
            /* border: 1px solid ${COLORS.gainsboro}; */
            border: 1px solid ${getColor("secondary")};
            border-radius: 3px 20px 20px 3px;
            background-color: rgba(244, 244, 244, 0.500792);
            margin-left: 40px;
            position: relative;
            margin-top: 14px;
            padding: 5px;
            span {
                font-family: ${TYPOGRAPHY.fontFamily.dosis};
                color: ${getColor("primary")} !important;
                font-size: ${TYPOGRAPHY.size.small} !important;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                padding-right: 28px;
                display: inline-block;
                &:focus {
                    color: ${COLORS.secondaryNavyOne} !important;
                }
                &:hover {
                    color: ${COLORS.secondaryNavyOne}!important;
                }
            }
            &:hover,
            &:active {
                &:after {
                    background-color: ${COLORS.yellow};
                }
            }
            &::after {
                content: "";
                width: 10px;
                margin-left: 10px;
                height: 10px;
                border: 1px solid;
                border-radius: 50%;
                background-color: ${COLORS.white};
                display: inline-block;
                border: 0.25px solid rgba(17, 41, 69, 0.219214);
                box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.638631);
                right: 14px;
                top: 14px;
                position: absolute;
                top: 50%;
                transform: translate(0, -50%);
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 310px;
                        margin-top: 15px !important ;
                        font-size: ${TYPOGRAPHY.size.tiny};
                        margin-left: 20px;
                        padding: 5px;
                    `,
                    css`
                        max-width: 370px;
                        margin-top: 10px !important;
                        margin-left: 20px;
                        padding: 5px;
                    `,
                    css`
                        max-width: 380px;
                        margin-top: 10px !important;
                        margin-left: 20px;
                        padding: 5px;
                    `,
                    null,
                    null,
                ])}
        }
        .MasterfluxLinkButton {
            max-width: 360px;
            border: 1px solid ${getColor("secondary")};
            border-radius: 3px 20px 20px 3px;
            background-color: #332a86;
            margin-left: 40px;
            position: relative;
            margin-top: 14px;
            padding: 5px;
            span {
                font-family: ${TYPOGRAPHY.fontFamily.dosis};
                color: white !important;
                font-size: ${TYPOGRAPHY.size.small} !important;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                padding-right: 28px;
                display: block;
                &:focus {
                    color: white !important;
                }
                &:hover {
                    color: white !important;
                }
            }
            &:hover,
            &:active {
                &:after {
                    background-color: ${COLORS.yellow};
                }
            }
            &::after {
                content: "";
                width: 10px;
                margin-left: 10px;
                height: 10px;
                border: 1px solid;
                border-radius: 50%;
                background-color: ${COLORS.white};
                display: inline-block;
                border: 0.25px solid rgba(17, 41, 69, 0.219214);
                box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.638631);
                right: 14px;
                top: 14px;
                position: absolute;
                top: 50%;
                transform: translate(0, -50%);
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 310px;
                        margin-top: 15px !important ;
                        font-size: ${TYPOGRAPHY.size.tiny};
                        margin-left: 20px;
                        padding: 5px;
                    `,
                    css`
                        max-width: 370px;
                        margin-top: 10px !important;
                        margin-left: 20px;
                        padding: 5px;
                    `,
                    css`
                        max-width: 380px;
                        margin-top: 10px !important;
                        margin-left: 20px;
                        padding: 5px;
                    `,
                    null,
                    null,
                ])}
        }
        .TechnologyTecumsehButton {
            max-width: 60%;
            border: 1px solid ${COLORS.normalGray};
            border-radius: 3px 20px 20px 3px;
            /* border: 0.2 solid ${COLORS.secondaryNavyOne}; */
            border: 0.2 solid ${getColor("secondary")};
            background-color: rgba(244, 244, 244, 0.500792);
            margin-top: 15px;
            height: auto;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
            font-size: ${TYPOGRAPHY.size.smallest};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            text-transform: uppercase;
            position: relative;
            span {
                color: ${getColor("primary")} !important;
            }
            &:active,
            &:hover {
                &:after {
                    background-color: ${COLORS.yellow};
                }
            }
            &::after {
                content: "";
                width: 10px;
                margin-left: 10px;
                height: 10px;
                border: 1px solid;
                border-radius: 50%;
                background-color: ${COLORS.background.base};
                display: inline-block;
                color: ${COLORS.black};
                right: 14px;
                top: 14px;
                position: absolute;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        border: 1px solid ${COLORS.normalGray};
                        border-radius: 3px 20px 20px 3px;
                        background-color: rgba(244, 244, 244, 0.500792);
                        margin-top: 15px;
                        height: auto;
                        font-size: ${TYPOGRAPHY.size.tiny};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        text-transform: uppercase;
                        margin-bottom: 10px;
                    `,
                    css`
                        max-width: 100%;
                        border: 1px solid grey;
                        border-radius: 3px 20px 20px 3px;
                        background-color: rgba(244, 244, 244, 0.500792);
                        margin-top: 15px;
                        height: auto;
                        font-size: ${TYPOGRAPHY.size.tiny};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        text-transform: uppercase;
                        margin-bottom: 10px;
                    `,
                    css`
                        max-width: 100%;
                        border: 1px solid grey;
                        border-radius: 3px 20px 20px 3px;
                        background-color: rgba(244, 244, 244, 0.500792);
                        margin-top: 15px;
                        height: auto;
                        font-size: ${TYPOGRAPHY.size.tiny};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        text-transform: uppercase;
                        margin-bottom: 10px;
                    `,
                    null,
                    null,
                ])}
        }
        .TechnologyMasterfluxButton {
            max-width: 60%;
            border: 1px solid ${COLORS.normalGray};
            border-radius: 3px 20px 20px 3px;
            border: 0.2 solid ${getColor("secondary")};
            background-color: #332a86;
            margin-top: 15px;
            height: auto;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
            font-size: ${TYPOGRAPHY.size.smallest};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            text-transform: uppercase;
            position: relative;
            span {
                color: white !important;
            }
            &:active,
            &:hover {
                &:after {
                    background-color: ${COLORS.yellow};
                }
            }
            &::after {
                content: "";
                width: 10px;
                margin-left: 10px;
                height: 10px;
                border: 1px solid;
                border-radius: 50%;
                background-color: ${COLORS.background.base};
                display: inline-block;
                color: ${COLORS.black};
                right: 14px;
                top: 14px;
                position: absolute;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        border: 1px solid ${COLORS.normalGray};
                        border-radius: 3px 20px 20px 3px;
                        margin-top: 15px;
                        height: auto;
                        font-size: ${TYPOGRAPHY.size.tiny};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        text-transform: uppercase;
                        margin-bottom: 10px;
                    `,
                    css`
                        max-width: 100%;
                        border: 1px solid grey;
                        border-radius: 3px 20px 20px 3px;
                        margin-top: 15px;
                        height: auto;
                        font-size: ${TYPOGRAPHY.size.tiny};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        text-transform: uppercase;
                        margin-bottom: 10px;
                    `,
                    css`
                        max-width: 100%;
                        border: 1px solid grey;
                        border-radius: 3px 20px 20px 3px;
                        margin-top: 15px;
                        height: auto;
                        font-size: ${TYPOGRAPHY.size.tiny};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        text-transform: uppercase;
                        margin-bottom: 10px;
                    `,
                    null,
                    null,
                ])}
        }
        .TechnologyMASTERFLUXSideBUTTON {
            height: 3px;
            padding: 13px 10px;
            padding-right: 30px;
            margin: 0 4px;
            border: 0;
            border-radius: 0 25px 25px 0;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            border: 0.25px solid ${getColor("secondary")} !important;
            color: white;
            border-radius: 0px 20px 20px 0px;
            width: 300px;
            opacity: 1;
            background-color: #332a86;
            position: relative;
            text-align: left;
            text-transform: uppercase;
            span {
                font-size: ${TYPOGRAPHY.size.small} !important;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                &:hover {
                    color: white;
                    font-size: ${TYPOGRAPHY.size.base} !important;
                }
            }
            &:hover {
                background-color: #332a86;
                &:after {
                    background-color: ${COLORS.yellow};
                }
            }

            &:active {
                background-color: #332a86;
                border: 0.25px solid #332a86 !important;
                &:after {
                    background-color: ${COLORS.yellow};
                }
            }
            &:focus {
                outline: none;
            }
            &:after {
                content: "";
                width: 10px;
                margin-left: 10px;
                height: 10px;
                position: absolute;
                right: 9px;
                top: 15px;
                border-radius: 13px;
                border: 0.25px solid rgba(17, 41, 69, 0.219214);
                box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.638631) inset;
                opacity: 1;
                background-color: ${COLORS.background.whiteSmoke};
                display: inline-block;
                color: ${COLORS.black};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        span {
                            font-size: ${TYPOGRAPHY.size.smaller} !important;
                        }
                    `,
                    css``,
                    css``,
                    css`
                        width: 250px;
                    `,
                    null,
                ])}
        }
        .TECTECHNOLOGYsidebutton {
            height: 3px;
            padding: 13px 10px;
            padding-right: 30px;
            margin: 0 4px;
            border: 0;
            border-radius: 0 25px 25px 0;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            border: 0.25px solid ${getColor("secondary")} !important;
            color: ${getColor("primary")};
            border-radius: 0px 20px 20px 0px;
            width: 300px;
            opacity: 1;
            background-color: ${COLORS.background.base};
            position: relative;
            text-align: left;
            text-transform: uppercase;
            span {
                font-size: ${TYPOGRAPHY.size.small} !important;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                &:hover {
                    color: ${getColor("secondary")};
                    font-size: ${TYPOGRAPHY.size.base} !important;
                }
            }
            &:hover {
                background-color: ${COLORS.background.base};
                &:after {
                    background-color: ${COLORS.yellow};
                }
            }
            &:active {
                background-color: ${COLORS.background.base};
                border: 0.25px solid ${COLORS.secondaryNavyOne} !important;
                &:after {
                    background-color: ${COLORS.yellow};
                }
            }
            &:focus {
                outline: none;
            }
            &:after {
                content: "";
                width: 10px;
                margin-left: 10px;
                height: 10px;
                position: absolute;
                right: 9px;
                top: 15px;
                border-radius: 13px;
                border: 0.25px solid rgba(17, 41, 69, 0.219214);
                box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.638631) inset;
                opacity: 1;
                background-color: ${COLORS.background.whiteSmoke};
                display: inline-block;
                color: ${COLORS.black};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        span {
                            font-size: ${TYPOGRAPHY.size.smaller} !important;
                        }
                    `,
                    css``,
                    css``,
                    css`
                        width: 250px;
                    `,
                    null,
                ])}
        }
        .TecbannerButton {
            border-radius: 18px;
            border: 0.25px solid ${COLORS.fuscousGrey};
            opacity: 1;
            background-color: ${COLORS.background.base};
            padding: 3px 10px;
            margin-top: 7px;
            &:hover {
                .circleIcon {
                    background: ${COLORS.yellow};
                    border: 0.25px solid rgba(17, 41, 69, 0.22);
                    box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.64);
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 50%;
                        `,
                        css`
                            width: 50%;
                        `,
                        css`
                            width: 20%;
                        `,
                        null,
                    ],
                    "minMax",
                )}
        }
        .masterfluxBannerLINK {
            border-radius: 18px;
            border: 0.25px solid #332a86;
            opacity: 1;
            background-color: #332a86;
            padding: 3px 10px;
            margin-top: 7px;
            &:hover {
                .circleIcon {
                    background: ${COLORS.yellow};
                    border: 0.25px solid rgba(17, 41, 69, 0.22);
                    box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.64);
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 50%;
                        `,
                        css`
                            width: 50%;
                        `,
                        css`
                            width: 20%;
                        `,
                        null,
                    ],
                    "minMax",
                )}
        }
    `,
};
